import DeleteIcon from '@mui/icons-material/Delete'
import IconButton from '@mui/material/IconButton'
import { reExportedColors, ITooltip } from '../../index'

const GarbageBinIconButton = ({ className, onClick, disabled, fontSize, active }) => (
  <ITooltip placement='top' content='Delete'>
    <IconButton
      className={className}
      disabled={disabled}
      onClick={onClick}
      sx={{
        backgroundColor: active ? reExportedColors.DARK_GREY : undefined,
        color: active ? reExportedColors.WHITE : undefined,
        padding: '6px',
        width: '36px',
        '&:hover': {
          backgroundColor: active ? reExportedColors.DARK_GREY : undefined
        }
      }}
    >
      <DeleteIcon fontSize={fontSize} />
    </IconButton>
  </ITooltip>
)

export default GarbageBinIconButton
